<label class="filter-label"><span>{{property.name}}</span><span class="after">{{afterProperty}}&nbsp;</span></label>
<be-input placeholder="" [formGroup]="formGroup" controlName="control" [property]="property"></be-input>
